module.exports = __webpack_public_path__ + "static/img/logo_pf.600143e6.png";